import type { MyObjectStatus } from './types'

export const DEFAULT_MY_OBJECT_STATUS: MyObjectStatus = 'active'
export const MY_OBJECTS_PAGE_SIZE = 20
